module.exports = __webpack_public_path__ + "img/the_chessecake_factory.259b7cf8.jpg";